import React from "react";
const Unauthorized = () => {
 return <div>You donot have permission to view this page</div>;
};
export default Unauthorized;